import { FC } from 'react';

import { SuggestionsCardsWrapper } from '../SearchSuggestions.styles';
import { ProductCardSkeleton } from './Skeletons.styles';

export const ProductCardsSkeleton: FC = () => {
    return (
        <SuggestionsCardsWrapper>
            <ProductCardSkeleton />
            <ProductCardSkeleton />
            <ProductCardSkeleton />
            <ProductCardSkeleton />
        </SuggestionsCardsWrapper>
    );
};
